// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Plans__FormController from "./plans/form_controller"
application.register("plans--form", Plans__FormController)

import Classrooms__DeliveriesFormController from "./classrooms/deliveries_form_controller"
application.register("classrooms--deliveries-form", Classrooms__DeliveriesFormController)

import Classrooms__DeliveriesSidebarController from "./classrooms/deliveries_sidebar_controller"
application.register("classrooms--deliveries-sidebar", Classrooms__DeliveriesSidebarController)

import Classrooms__DeliveriesConfigFormController from "./classrooms/deliveries_config_form_controller"
application.register("classrooms--deliveries-config-form", Classrooms__DeliveriesConfigFormController)

import Roles__FormController from "./roles/form_controller"
application.register("roles--form", Roles__FormController)

import Vitrines__FormController from "./vitrines/form_controller"
application.register("vitrines--form", Vitrines__FormController)

import Offers__BumpFormController from "./offers/bump_form_controller"
application.register("offers--bump-form", Offers__BumpFormController)

import CheckoutSessions__FormController from "./checkout_sessions/form_controller"
application.register("checkout-sessions--form", CheckoutSessions__FormController)

import CheckoutSessions__ShowController from "./checkout_sessions/show_controller"
application.register("checkout-sessions--show", CheckoutSessions__ShowController)

import Orders__ConfirmController from "./orders/confirm_controller"
application.register("orders--confirm", Orders__ConfirmController)

import Orders__RejectController from "./orders/reject_controller"
application.register("orders--reject", Orders__RejectController)

import Subscriptions__ShowController from "./subscriptions/show_controller"
application.register("subscriptions--show", Subscriptions__ShowController)

import Events__FormController from "./events/form_controller"
application.register("events--form", Events__FormController)

import Products__FormController from "./products/form_controller"
application.register("products--form", Products__FormController)

import Integrations__MundipaggHubController from "./integrations/mundipagg_hub_controller"
application.register("integrations--mundipagg-hub", Integrations__MundipaggHubController)
